/**
    * @description      : 
    * @author           : 
    * @group            : 
    * @created          : 07/08/2025 - 17:34:08
    * 
    * MODIFICATION LOG
    * - Version         : 1.0.0
    * - Date            : 07/08/2025
    * - Author          : 
    * - Modification    : 
**/

import { doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../firebase";

const getDocumentById = async (collectionName: string, docId: string) => {
  // Add validation to prevent Firebase errors
  if (!collectionName || !docId) {
      console.error("Invalid collection name or document ID:", { collectionName, docId });
      return null;
  }
  
  try {
      const docRef = doc(db, collectionName, docId);
      const docSnap = await getDoc(docRef);
      
      if (docSnap.exists()) {
          return docSnap.data();
      } else {
          console.log("No such document!");
          return null;
      }
  } catch (error) {
      console.error("Error fetching document:", error);
      return null;
  }
};

const updateDocument = async (collectionName: string, docId: string, data: object) => {
  // Add validation to prevent Firebase errors
  if (!collectionName || !docId) {
      console.error("Invalid collection name or document ID:", { collectionName, docId });
      throw new Error("Invalid collection name or document ID");
  }
  
  try {
      const docRef = doc(db, collectionName, docId);
      await updateDoc(docRef, data);
  } catch (error) {
      console.error("Error updating document:", error);
      throw error;
  }
};



export  {getDocumentById,updateDocument}